(() => {
  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function initCatalog(catalog) {
    if (catalog.dataset.cdgCatalogInitialized === 'true') return;
    catalog.dataset.cdgCatalogInitialized = 'true';
    const drawer = catalog.querySelector('[data-cdg-filter-drawer]');
    const openButton = catalog.querySelector('[data-cdg-filter-open]');
    const closeButtons = catalog.querySelectorAll('[data-cdg-filter-close]');
    let returnFocus = null;

    function setDrawer(open) {
      if (!drawer || !openButton) return;
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', String(!open));
      openButton.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('cdg-lock-scroll', open);
      if (open) {
        returnFocus = document.activeElement;
        drawer.querySelector(focusableSelector)?.focus();
      } else {
        (returnFocus || openButton).focus();
      }
    }

    openButton?.addEventListener('click', () => setDrawer(true));
    closeButtons.forEach((button) => button.addEventListener('click', () => setDrawer(false)));
    drawer?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { event.preventDefault(); setDrawer(false); return; }
      if (event.key !== 'Tab') return;
      const items = [...drawer.querySelectorAll(focusableSelector)].filter((item) => item.offsetParent !== null);
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    });

    catalog.querySelectorAll('[data-cdg-sort]').forEach((select) => select.addEventListener('change', () => select.form?.requestSubmit()));

    catalog.querySelectorAll('[data-cdg-filter-form]').forEach((form) => {
      form.classList.add('is-enhanced');
      let timer;
      form.addEventListener('change', (event) => {
        if (!event.target.matches('input[type="checkbox"]')) return;
        window.clearTimeout(timer);
        timer = window.setTimeout(() => form.requestSubmit(), 120);
      });
    });
  }

  function initPredictive(root) {
    root.querySelectorAll('[data-cdg-predictive]').forEach((component) => {
      if (component.dataset.cdgPredictiveInitialized === 'true') return;
      component.dataset.cdgPredictiveInitialized = 'true';
      const input = component.querySelector('[data-cdg-predictive-input]');
      const panel = component.querySelector('[data-cdg-predictive-panel]');
      let controller;
      let timer;

      function close() {
        panel.hidden = true;
        input.setAttribute('aria-expanded', 'false');
      }

      async function search(term) {
        controller?.abort();
        controller = new AbortController();
        panel.hidden = false;
        panel.innerHTML = '<p class="cdg-predictive-status" aria-busy="true">Buscando…</p>';
        input.setAttribute('aria-expanded', 'true');
        const params = new URLSearchParams({
          q: term,
          'resources[type]': 'product',
          'resources[limit]': '6',
          section_id: 'cdg-predictive-search'
        });
        try {
          const response = await fetch(`/search/suggest?${params}`, { signal: controller.signal, headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          panel.innerHTML = await response.text();
        } catch (error) {
          if (error.name === 'AbortError') return;
          panel.innerHTML = '<div class="cdg-predictive-empty" role="status"><strong>Busca temporariamente indisponível</strong><span>Pressione Enter para buscar pelo termo completo.</span></div>';
        }
      }

      input.addEventListener('input', () => {
        window.clearTimeout(timer);
        const term = input.value.trim();
        if (term.length < 2) { close(); return; }
        timer = window.setTimeout(() => search(term), 220);
      });
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { close(); input.focus(); }
        if (event.key !== 'ArrowDown' || panel.hidden) return;
        const first = panel.querySelector('a[href]');
        if (first) { event.preventDefault(); first.focus(); }
      });
      panel.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { event.preventDefault(); close(); input.focus(); }
      });
      document.addEventListener('click', (event) => { if (!component.contains(event.target)) close(); });
    });
  }

  function init(root = document) {
    root.querySelectorAll('[data-cdg-catalog]').forEach(initCatalog);
    initPredictive(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
